<template>
  <app-page>
    <div class="contact">
      <div class="header">
        <img src="@/assets/images/about/contact_cover.png" alt="" class="cover">
      </div>
      <div class="content">
        <div class="number-title">
          <span class="number">01</span>
          <h2 class="title">
          <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
            <span class="text">公司地址</span>
            <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
          </h2>
        </div>
        <div class="addresses">
          <div class="address" v-for="(value,index) in addresses" :key="index">
            <div class="detail">
             <span class="icon">
            <img src="@/assets/svg/about/ic_site.svg" alt="">
          </span>
              <div class="info">
                <h3>{{value.city}}</h3>
                <p>{{value.address}}</p>
              </div>
            </div>
            <div class="location">
              <img :src="value.location" alt="">
            </div>

          </div>
        </div>
        <div class="number-title">
          <span class="number">02</span>
          <h2 class="title">
          <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
            <span class="text">微信公众号</span>
            <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
          </h2>
        </div>
        <div class="wechat-qrcode">
          <div class="qrcode-item">
            <img src="@/assets/images/about/contact_wechat_qrcode_1.png" alt="">
            <p>jaadee321</p>
          </div>
          <div class="qrcode-item">
            <img src="@/assets/images/about/contact_wechat_qrcode_2.png" alt="">
            <p>jaadeecom</p>
          </div>
        </div>
        <div class="number-title">
          <span class="number">03</span>
          <h2 class="title">
          <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
            <span class="text">微信销售号</span>
            <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
          </h2>
        </div>
        <div class="customer-service">
          <p class="service-phone">
            客服电话：400-629-1314 <span class="button">点击拨打</span>
          </p>
          <div class="service-number">
            <span v-for="(value,index) in services" :key="index" :class="{'left-text':(index%2)==0}" >微信客服：{{value}}</span>

          </div>
        </div>
        <div class="number-title">
          <span class="number">04</span>
          <h2 class="title">
          <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
            <span class="text">微信销售号</span>
            <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
          </h2>
        </div>
        <div class="weibo">
          <h3 class="title">新浪微博： weibo.com/daderui </h3>
          <p>点击直接访问新浪微博手机触屏版</p>
        </div>
        <div class="number-title">
          <span class="number">05</span>
          <h2 class="title">
          <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
            <span class="text">投诉建议</span>
            <span class="icon">
            <img src="@/assets/svg/about/us_title_icon.svg" alt="">
          </span>
          </h2>
        </div>
        <div class="suggest">
          <p>1. 您可以发送电子邮件至muyunhai@foxmail.com进行投诉或建议 </p>
          <p>2. 你可以通过微信公众号：jaadee321或jaadeecom </p>
          <p>3. 投诉电话：18100891074（销售总监：双艳） </p>
        </div>
      </div>
      <about-footer></about-footer>
    </div>
  </app-page>
</template>

<script>
    import AppPage from '../layouts/Main';
    import AboutFooter from './components/AboutFooter';
    import location1 from '@/assets/images/about/contact_location_1.png';
    import location2 from '@/assets/images/about/contact_location_2.png';
    import location3 from '@/assets/images/about/contact_location_3.png';
    import location4 from '@/assets/images/about/contact_location_4.png';
    import location5 from '@/assets/images/about/contact_location_5.png';
    import location6 from '@/assets/images/about/contact_location_6.png';
    export default {
        name: 'contact',
        components: {
          AppPage,AboutFooter
        },
        data() {
            return {
                addresses:[
                  {
                    city:'云南·昆明',
                    address:'云南省昆明市人民中路169号(天昊大厦17A)',
                    location:location1
                  },
                  {
                    city:'云南·瑞丽',
                    address:'云南省瑞丽市金星石木文化城15栋1号',
                    location:location2
                  },
                  {
                    city:'广东·佛山',
                    address:'广东省佛山市平洲玉器街翠皇府大厦5F',
                    location:location3
                  },
                  {
                    city:'广东·佛山',
                    address:'广东省佛山市平洲翠宝园3栋46/47A',
                    location:location4
                  },
                  {
                    city:'广州·广州',
                    address:'广州市荔湾区下九路69号名汇大厦C座2202室',
                    location:location5
                  },
                  {
                    city:'江苏·苏州',
                    address:'江苏省苏州市姑苏区平江街道园林路52号',
                    location:location6
                  }
                ],
                services:['fcwc18','fcwc666','fcwc99','fcwc111','fcwclin','fcwc668','fcwc999','jaadee888','shuoyibueer2016']
            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
  .contact{
    background-color: rgba(255,255,255,1);
  }
  .content{
    text-align: left;
    padding: 0 0.21rem;
  }
  .header{
    height: 3.33rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .number-title{
    position: relative;
    margin-top: 0.4rem;
    text-align: center;
    margin-bottom: 0.21rem;
    .number{
      font-size:0.4267rem;
      font-weight:500;
      color:rgba(139,139,139,0.2);
      line-height:0.6rem;
    }
    .title{
      position: absolute;
      width: 100%;
      top: 0.27rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0 .2rem 0;
      .text{
        font-size:.28rem;
        color:rgba(155,124,70,1);
        line-height:.3933rem;
        font-weight:500;
        background:linear-gradient(90deg, rgba(4,109,26,1) 0%, rgba(2,66,11,1) 100%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        margin: 0 0.05rem;
      }
      .icon{
        width: .23rem;
        height: .16rem;
      }
    }
  }
  .addresses{
    .address{
      padding-bottom: .33rem;
      .detail{
        display: flex;
        align-items: center;
        .icon{
          width: 0.53rem;
          height: 0.53rem;
          margin-right: 0.21rem;
        }
        .info{
          text-align: left;
          h3{
            font-size:0.2133rem;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height:0.2133rem;
            margin-bottom: 0.12rem;
          }
          p{
            font-size:0.1867rem;
            font-weight:400;
            color:rgba(78,78,78,1);
            line-height:0.1867rem;
          }
        }
      }
      .location{
        margin-top: 0.2rem;
      }
    }
    .address:last-child{
      padding: 0;
    }
  }
  .wechat-qrcode{
    display: flex;
    .qrcode-item{
      flex-grow: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      img{
        width: 1.87rem;
        height: 1.87rem;
      }
      p{
        font-size:0.1867rem;
        font-weight:400;
        color:rgba(78,78,78,1);
        text-align: center;
      }
    }
  }
  .customer-service{
    font-size:0.1867rem;
    color:rgba(0,0,0,1);
    line-height:0.3rem;

    .service-phone{
      padding-bottom: 0.21rem;
      display: flex;
      align-items: center;
      .button{
        padding: 0.03rem 0.07rem;
        background-color: rgba(155, 124, 70, 0.1);
        border: 1px solid rgba(155, 124, 70, 1);
        border-radius: 1.4rem;
        font-size:0.1467rem;
        color:rgba(155,124,70,1);
        height: 0.27rem;
        display: flex;
        align-items: center;
        margin-left: 0.05rem;
      }
    }
    .service-number{
      display: flex;
      flex-wrap: wrap;
      span {
        padding-bottom: 0.21rem;
      }
      .left-text{
        min-width: 2.58rem;
      }
    }
  }
  .weibo{
    border-radius:0.08rem;
    border:0.0133rem solid rgba(155,124,70,1);
    padding: 0.23rem 0;
    margin: auto 0.1rem;
    text-align: center;
    h3{
      font-size:0.24rem;
      font-weight:500;
      color:rgba(155,124,70,1);
      line-height:0.3rem;
      padding-bottom: 0.05rem;
    }
    p{
      font-size:0.16rem;
      color:rgba(78,78,78,1);
      line-height:0.22rem;
    }
  }
  .suggest{
    font-size:0.1867rem;
    color:rgba(0,0,0,1);
    p{
      padding-bottom: 0.12rem;
    }
  }
</style>
